import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.modifiedFieldSets = new Set()
    this.disabledInputs = []

    this.handleChange = this.handleChange.bind(this)
    this.handleTrixChange = this.handleTrixChange.bind(this)
    this.handleSubmitStart = this.handleSubmitStart.bind(this)
    this.handleSubmitEnd = this.handleSubmitEnd.bind(this)

    this.element.addEventListener("change", this.handleChange)
    this.element.addEventListener("trix-change", this.handleTrixChange)
    this.element.addEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  handleChange(event) {
    var fieldSet = event.target.closest('.field_set')
    if (fieldSet) this.modifiedFieldSets.add(fieldSet)
  }

  handleTrixChange(event) {
    var fieldSet = event.target.closest('.field_set')
    if (fieldSet) this.modifiedFieldSets.add(fieldSet)
  }

  handleSubmitStart() {
    var allFieldSets = this.element.querySelectorAll('.field_set')
    this.disabledInputs = []

    allFieldSets.forEach(fieldSet => {
      if (this.modifiedFieldSets.has(fieldSet)) return

      // Keep fields for items marked for destruction (_destroy=1)
      var destroyField = fieldSet.querySelector('input[type="hidden"][name$="[_destroy]"]')
      if (destroyField && destroyField.value === "1") return

      // Keep fields for new unpersisted records (no id field)
      var idField = fieldSet.querySelector('input[type="hidden"][name$="[id]"]')
      if (!idField || !idField.value) return

      // Disable all inputs in this unmodified, persisted field set
      fieldSet.querySelectorAll('input, textarea, select').forEach(input => {
        if (!input.disabled) {
          input.disabled = true
          this.disabledInputs.push(input)
        }
      })
    })
  }

  handleSubmitEnd() {
    this.disabledInputs.forEach(input => { input.disabled = false })
    this.disabledInputs = []
  }

  disconnect() {
    this.element.removeEventListener("change", this.handleChange)
    this.element.removeEventListener("trix-change", this.handleTrixChange)
    this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }
}
